import { LeagueRowView } from '../../../../../core/views/components';
import templates from './templates';
import './index.styl';

export default class CompRowView extends LeagueRowView {
	get template() {
		const type_page = this.getOption('type_page');

		let result;

		switch (type_page) {
			case 'join':
				result = templates.joinComp;
				break;
			case 'regenerate':
				result = templates.regenerateComp;
				break;
			default :
				result = templates.showComp;
		}

		return result;
	}

	initialize() {
		const {
			user
		} = this.options;

		this.model
			.set( {
				my_team: user.toJSON()
			} )
			.checkAccessToLeague( user.id )
			.checkIsPossibleLeave()
			.setAvatar()
			.updateUserName()
			.isStarted()
			.checkAccessToSettings();
	}
}